export function AddFileIcon({
  className = "size-5",
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M11.6667 1.89127V5.33339C11.6667 5.8001 11.6667 6.03346 11.7575 6.21172C11.8374 6.36852 11.9649 6.496 12.1217 6.5759C12.3 6.66672 12.5333 6.66672 13 6.66672H16.4422M10 15V10M7.50004 12.5H12.5M11.6667 1.66666H7.33337C5.93324 1.66666 5.23318 1.66666 4.6984 1.93915C4.22799 2.17883 3.84554 2.56128 3.60586 3.03169C3.33337 3.56647 3.33337 4.26653 3.33337 5.66666V14.3333C3.33337 15.7335 3.33337 16.4335 3.60586 16.9683C3.84554 17.4387 4.22799 17.8212 4.6984 18.0608C5.23318 18.3333 5.93324 18.3333 7.33337 18.3333H12.6667C14.0668 18.3333 14.7669 18.3333 15.3017 18.0608C15.7721 17.8212 16.1545 17.4387 16.3942 16.9683C16.6667 16.4335 16.6667 15.7335 16.6667 14.3333V6.66666L11.6667 1.66666Z" stroke="#101828" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "AddFileIcon";
